import React, { useContext, useEffect, useState } from "react";
import { finddoctorservice } from "../../services/findDoctor.services";
import Parser from "html-react-parser";
import AuthContext from "../../store/auth-context";
import { useTranslation } from "react-i18next";
import { pushToDataLayer } from "../../utils/gtm";

function DoctorProfile(props: any) {
  const authCtx = useContext(AuthContext);
  const { t } = useTranslation();
  const [doctorProfileData, setDoctorprofileData] = useState<any>();

  useEffect(() => {
    fetcDoctorProfileDetails();
    // eslint-disable-next-line
  }, []);

  const fetcDoctorProfileDetails = async () => {
    authCtx.toggleLoader(true);
    const res = await finddoctorservice.getDoctorProfile(
      props.doctorProfileDetails
    );
    if (res && res.data && res.data.status === "success") {
      setDoctorprofileData(res.data.data[0]);
      const docData = res.data.data[0];
      pushToDataLayer({
        event: 'doctor_profile_view',
        doctor_name: docData.name,
        specialty_name: docData.specialization,
        brand_name: docData.brandName || 'Burjeel'
      });
    } else {
      setDoctorprofileData([]);
      console.log(res.message);
    }
    authCtx.toggleLoader(false);
  };

  return (
    <>
      <div className="d-flex justify-content-start align-item-cenetr ">
        <div className="flex-shrink-0">
          <img
            src={doctorProfileData && doctorProfileData.image}
            alt="news"
            className="img-fluid img-150 rounded dr-photo"
          />
        </div>
        <div className="flex-fill ms-3">
          <h6 className="fw-bold">
            {doctorProfileData && doctorProfileData.name}
          </h6>
          <p className="text-muted fs-12 m-0">
            {doctorProfileData && doctorProfileData.specialization}
          </p>
          <hr />
          <p className="fs-14">
            {t("Years of Experience")} :{" "}
            <b>{doctorProfileData && doctorProfileData.experience}</b>
          </p>
          <p className="fs-14">
            {t("Nationality")} :{" "}
            <b>{doctorProfileData && doctorProfileData.nationality}</b>
          </p>
          <p className="fs-14">
            {t("Languages Known")} :{" "}
            <b>{doctorProfileData && doctorProfileData.know_langauges}</b>
          </p>
        </div>
      </div>
      <div className="flex-fill">
        <h6 className="fw-500">{t("Biography")}</h6>
        {doctorProfileData && (
          <div>{Parser(doctorProfileData.biography_web)}</div>
        )}
      </div>
    </>
  );
}

export default DoctorProfile;
